import React from "react";
import { cn } from "@/lib/utils";

const statusStyles: Record<string, string> = {
  active: "bg-green-50 text-green-700 border-green-200",
  inactive: "bg-gray-50 text-gray-600 border-gray-200",
  pending: "bg-yellow-50 text-yellow-700 border-yellow-200",
  paused: "bg-orange-50 text-orange-700 border-orange-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  deleted: "bg-red-50 text-red-600 border-red-200",
  paid: "bg-green-50 text-green-700 border-green-200",
  unpaid: "bg-yellow-50 text-yellow-700 border-yellow-200",
  public: "bg-blue-50 text-blue-700 border-blue-200",
  require_approval: "bg-yellow-50 text-yellow-700 border-yellow-200",
  private: "bg-gray-50 text-gray-600 border-gray-200",
};

interface StatusBadgeProps {
  status: string;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const label = status.replace(/_/g, " ");
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize",
        statusStyles[status] || "bg-gray-50 text-gray-600 border-gray-200",
        className,
      )}
    >
      {label}
    </span>
  );
}
